<template>
  <div class="designfile-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('designfile_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-file-cad</v-icon>{{$t('designfile.designfiles')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <DesignFileFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @click:row="showHandler"
@contextmenu:row="showHandlerExt"
            @update:options="onUpdateOptions"
          >
          <template slot="item.tags" slot-scope="{ item }">
            <div id="tags">
            <v-chip v-for="tag in item['tags']" :key="tag.id"
              class="ma-1 font-weight-bold"

              color="accent"
            >
              {{ tag.name }}
            </v-chip>
          </div>
          </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import DesignFileFilterForm from '../../components/designfile/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'DesignFileList',
  servicePrefix: 'DesignFile',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    DesignFileFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('designfile.nda'), value: 'nda'},
        { text: this.$t('designfile.type'), value: 'type.name' },
        { text: this.$t('designfile.tags'), value: 'tags' },
        { text: this.$t('designfile.ref'), value: 'ref' },
        { text: this.$t('global.createdby'), value: 'createdBy.login' },
        { text: this.$t('designfile.customer'), value: 'customer.name'}
      ],
  selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('designfile', {
      items: 'list'
    }),
    ...mapFields('designfile', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('designfile', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
